import { FC } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconLikeFilled } from '../../../../icon/IconLikeFilled';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';

export interface SaveSuccessContentProps {
    collectionName?: string;
}

export const SaveSuccessContent: FC<SaveSuccessContentProps> = ({ collectionName }) => {
    const t = useTranslation();

    return (
        <Flex
            direction="column"
            alignItems="center"
            justifyContent="center"
            flex={1}
            width="100%"
            px={4}
            py={8}
        >
            <Flex
                alignItems="center"
                justifyContent="center"
                width={80}
                height={80}
                borderRadius="50%"
                backgroundColor="var(--background-secondary)"
                mb={3}
            >
                <IconLikeFilled fontSize={40} color="var(--color-primary)" />
            </Flex>

            <Typography variant="title2" weight="bold" textAlign="center" mb={2}>
                {t('Пост сохранён')}
            </Typography>

            <Typography
                variant="body"
                color="var(--color-secondary)"
                textAlign="center"
                maxWidth="300px"
            >
                {collectionName
                    ? `${t('Пост добавлен в коллекцию')} «${collectionName}»`
                    : t('Пост успешно добавлен в коллекцию')}
            </Typography>
        </Flex>
    );
};
